import { Link } from 'react-router-dom';
import { videoCategories } from '@/mocks/videos';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                  <i className="ri-play-fill text-background-50 text-lg"></i>
                </div>
                <span className="text-lg font-bold text-background-50 whitespace-nowrap">
                  豆花视频
                </span>
              </div>
              <p className="text-sm text-background-400 leading-relaxed">
                豆花视频网页版是您在线观看视频的最佳选择，无需下载安装任何软件，直接在浏览器中畅享海量高清视频内容。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                视频分类
              </h4>
              <ul className="space-y-2.5">
                {videoCategories.slice(0, 4).map((cat) => (
                  <li key={cat.id}>
                    <Link
                      to={`/category?tab=${cat.slug}`}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                更多分类
              </h4>
              <ul className="space-y-2.5">
                {videoCategories.slice(4).map((cat) => (
                  <li key={cat.id}>
                    <Link
                      to={`/category?tab=${cat.slug}`}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                关于我们
              </h4>
              <ul className="space-y-2.5">
                <li>
                  <Link
                    to="/about"
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    品牌介绍
                  </Link>
                </li>
                <li>
                  <Link
                    to="/about"
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    联系方式
                  </Link>
                </li>
                <li>
                  <a
                    href="#"
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    用户协议
                  </a>
                </li>
                <li>
                  <a
                    href="#"
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    隐私政策
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-background-500">
              &copy; 2025 豆花视频 douhuavideo.com 版权所有
            </p>
            <div className="flex items-center gap-4">
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 text-background-400 hover:text-background-50 transition-colors cursor-pointer"
                aria-label="微博"
              >
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 text-background-400 hover:text-background-50 transition-colors cursor-pointer"
                aria-label="微信"
              >
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 text-background-400 hover:text-background-50 transition-colors cursor-pointer"
                aria-label="B站"
              >
                <i className="ri-bilibili-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}